<template lang="pug">
button.button-custom(
    :id='id',
    :disabled='disabled',
    :class='disabled ? "--disable" : typeClass',
    :style="buttomClass"
)
    .button-icon.mdi(v-if='icon', :style='{ color, marginRight: label ? "5px" : "" }' :class='icon')
    .button-label(v-if='label') {{ label }}
</template>

<script>
export default {
    name: 'ButtonComponent',
    props: {
        id: {
            type: String,
            default: () => `button-input-${Math.ceil(Math.random() * 10000)}`,
        },
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
        backgroundColor: {
            type: String,
            default: 'var(--primary-green)',
        },
        color: {
            type: String,
            default: 'var(--primary-white)',
        },
        borderColor: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: null
        },
    },
    computed: {
        typeClass() {
            return this.type && !this.disabled ? this.type : '';
        },
        buttomClass() {
            if (!this.type) {
                return {
                    backgroundColor: this.backgroundColor,
                    color: this.color,
                    borderColor: this.borderColor
                }
            }
            return null;
        }
    }
};
</script>

<style>
.button-custom {
    display: flex !important;
    flex-direction: row;
    align-items: center;

    text-align: center;
    border: none;
    text-decoration: none;

    padding: 2px 5px 2px 5px;
    border-radius: 5px;

    height: 30px;

    display: inline-block;
    cursor: pointer;
    color: var(--primary-white);
    background-color: var(--primary-green);

    -webkit-box-shadow: 6px 5px 10px -8px rgba(0, 0, 0, 0.36);
    -moz-box-shadow: 6px 5px 10px -8px rgba(0, 0, 0, 0.36);
    box-shadow: 6px 5px 10px -8px rgba(0, 0, 0, 0.36);

    border: 1px solid transparent;
}

.--disable {
    opacity: 30%;
}

.btn-danger {
    min-width: 80px;
    background-color: rgb(242, 153, 113);
    color: var(--primary-red);
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
}

.btn-success {
    min-width: 80px;
    background-color: rgba(53, 145, 56, 0.3);
    color: var(--secondary-green) !important;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
}
</style>
